import React, { useState } from "react";

const ChainButton = ({ selectedChain, onChainSelect }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const chains = ["mainnet", "base"];

  const handleChainSelect = (chain) => {
    onChainSelect(chain);
    setIsExpanded(false);
  };

  return (
    <div className={`chain-button ${isExpanded ? "expanded" : ""}`}>
      {/* Collapsed State */}
      {!isExpanded && (
        <div
          className="chain-button-collapsed"
          onClick={() => setIsExpanded(true)}
        >
          <img
            src={`/${selectedChain}.png`}
            alt={selectedChain}
            className="chain-logo"
          />
          <img src="/downBtn.png" alt="expand" className="down-button" />
        </div>
      )}

      {/* Expanded State */}
      {isExpanded && (
        <div className="chain-button-expanded">
          {/* Selected Chain Row */}
          <div
            className="chain-row selected"
            onClick={() => setIsExpanded(false)}
          >
            <img
              src={`/${selectedChain}.png`}
              alt={selectedChain}
              className="chain-logo"
            />
            <img src="/checkmark.png" alt="selected" className="checkmark" />
          </div>

          {/* Unselected Chain Row */}
          <div
            className="chain-row unselected"
            onClick={() =>
              handleChainSelect(chains.find((chain) => chain !== selectedChain))
            }
          >
            <img
              src={`/${chains.find((chain) => chain !== selectedChain)}.png`}
              alt="alternative chain"
              className="chain-logo"
            />
            <div className="checkmark" />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChainButton;
